import * as React from "react"

export default function MyEventsOutlineIcon(props) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14 2a.667.667 0 01.667.667v3.666a1.667 1.667 0 000 3.334v3.666A.667.667 0 0114 14H2a.666.666 0 01-.667-.667V9.667a1.667 1.667 0 000-3.334V2.667A.667.667 0 012 2h12zm-.666 1.333H2.667v1.979l.104.054a3 3 0 011.56 2.493L4.333 8a3 3 0 01-1.562 2.633l-.104.055v1.979h10.666v-1.98l-.104-.053a3 3 0 01-1.56-2.493L11.667 8c0-1.136.631-2.125 1.563-2.633l.104-.056V3.333z"
        fill={props.fill}
      />
    </svg>
  )
}


